import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../form-components/input/Button";
import { toast } from 'react-toastify';


interface LocationState {
  email: string;
}

const VerifyEmail: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const location = useLocation();
  const { email } = location.state as LocationState;
  const navigate = useNavigate();

  const handleVerify = async () => {
    setStatus('loading');
    try {
      const response = await fetch('https://backend-kyw8.onrender.com/resend-2fa', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        console.log(email)
        throw new Error('Verification failed');
      }

      const data = await response.json();
      console.log(data);
      setStatus('success');
      navigate(`/otp`, {
        state: {
          email,
        },
      });
    } catch (err) {
      const error = err as Error;
      console.error('Error:', error.message);
      setStatus('error');
      toast.error('Unable to verify your Email Address. Please try again later.', {
        position: 'bottom-right',
      });
    } finally {
      setStatus('idle');
    }
  };

  return (
    <div className='main-div'>
      <div className='form-div md:w-full flex flex-col gap-6 border border-[#222222] rounded-[20px]'>
        <h2 className='text-black font-semibold text-3xl text-center'>
          Complete Your Registration
        </h2>
        <Button
          onClick={handleVerify}
          isLoading={status === 'loading'}
          buttonText='verify your email'
        />
      </div>
    </div>
  );
};

export default VerifyEmail;
